import {Box, Button, Fade, Grid, LinearProgress, MenuItem, Modal, Pagination, Paper, Tab, Table, TableBody, TableCell, TableHead, TableRow, TextField, Typography} from "@mui/material";
import {withStyles} from "@mui/styles";
import axios from 'axios';
import * as React from "react";
import {Config} from '../../config/config';
import {Helpers} from '../../utils/helpers';
import {PopupMessage} from '../../utils/message';
import {DateTimePicker, LocalizationProvider} from "@mui/lab";
import AdapterDateFns from "@mui/lab/AdapterDateFns";

class PlayerRubyLogsMain extends React.Component<any, any> {
    constructor(props: any) {
        super(props);
        const now = new Date();
        const weekAgo = new Date(now.getTime() - 7 * 24 * 60 * 60 * 1000);

        this.state = {
            loading: false,
            filter: {
                offset: 0,
                limit: 100,
                startTime: weekAgo,
                endTime: now,
            },
            userId: this.props.playerId,
            logs: [],
            total: 0
        }
    }

    componentDidMount(): void {
        this.onSearch();
    }

    onChangeFilter(key: string, value: any) {
        const {filter} = this.state;

        filter[key] = value;

        this.setState({filter});
    }

    handleChangeType = () => {
        const {filter} = this.state;

        filter.type = filter.type === 'attack' ? 'defense' : 'attack';

        this.setState({filter});
    }

    setLoading = (loading: boolean) => {
        this.setState({loading});
    }

    copyToClipboard(text: string) {
        navigator.clipboard.writeText(text);

        PopupMessage.success("Copied to clipboard");
    }

    onSearch = async () => {
        const {filter} = this.state;
        this.setLoading(true);
        const userId = this.state.userId;

        const url = `${Config.getInstance.apiUrl}/api/user/${userId}/ruby_log`;
        const headers = {
            Authorization: Helpers.getSessionId(),
        }

        const params = {
            startTime: filter.startTime.toISOString(),
            endTime: filter.endTime.toISOString(),
            limit: filter.limit,
            offset: filter.offset,
        }

        const response = await axios.get(url, {headers, params});
        const data = response.data;
        const success = data.success;

        this.setLoading(false);

        if (success) {
            const {logs, total} = data;

            this.setState({logs, total});
        } else {
            PopupMessage.error(`Getting ruby log failed. ${data.message}`)
        }
    }

    onClearFilter = () => {
        const {filter} = this.state;

        filter.limit = 10;
        filter.offset = 0;

        this.setState({filter});
    }

    formatNumber(number) {
        // Format 1000000 to 1,000,000
        return number.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
    }

    handleChangeTime = (key: string, value: any) => {
        this.setState({
            [key]: value,
        });
    }

    changePage = (page: number) => {
        const {filter} = this.state;
        const offset = (page - 1) * filter.limit;

        offset >= 0 ? filter.offset = offset : filter.offset = 0;

        this.setState({filter});

        this.onSearch();
    }

    onSort = (type: string) => {
        const {logs} = this.state;
        if (type === 'newest') {

            // Sort by date: newest
            logs.sort((a, b) => {
                return new Date(b.date).getTime() - new Date(a.date).getTime();
            });
        } else {
            // Sort by date: oldest
            logs.sort((a, b) => {
                return new Date(a.date).getTime() - new Date(b.date).getTime();
            });
        }

        this.setState({logs});
    }

    renderFilter = () => {
        const style = {
            // height: '100px',
            padding: '10px',
            width: '100%',
            // backgroundColor: "black",
        } as React.CSSProperties;

        const {filter} = this.state;

        return <Paper style={style} >
            <Grid container sm={12} spacing={2} rowSpacing={2}>
                <Grid item container sm={12}>
                    <Grid item sm={2}>
                        <LocalizationProvider dateAdapter={AdapterDateFns}>
                            <DateTimePicker
                                label="Start Time"
                                value={filter.startTime}
                                onChange={(e) => this.handleChangeTime("startTime", e)}
                                renderInput={(params) => <TextField {...params} size="small" />}
                                ampm={false}
                            />
                        </LocalizationProvider>
                    </Grid>

                    <Grid item sm={2}>
                        <LocalizationProvider dateAdapter={AdapterDateFns}>
                            <DateTimePicker
                                label="End Time"
                                value={filter.endTime}
                                onChange={(e) => this.handleChangeTime("endTime", e)}
                                renderInput={(params) => <TextField {...params} size="small" />}
                                ampm={false}
                            />
                        </LocalizationProvider>
                    </Grid>
                </Grid>
                <Grid item container sm={12} spacing={2} justifyContent={"flex-end"}>
                    <Grid item sm={1}>
                        <TextField
                            label="Page Size"
                            value={filter.limit}
                            onChange={(e) => this.onChangeFilter('limit', e.target.value)}
                            fullWidth
                            variant="outlined"
                        />
                    </Grid>
                    {/* <Grid item sm={1}>
                        <TextField
                            label="Offset..."
                            value={filter.offset}
                            onChange={(e) => this.onChangeFilter('offset', e.target.value)}
                            fullWidth
                            variant="outlined"
                            size="small"
                        />
                    </Grid> */}

                    <Grid item sm={2}>
                        <TextField
                            fullWidth
                            label="Sort By"
                            select
                            defaultValue={"newest"}
                            onChange={(e) => this.onSort(e.target.value)}
                        >
                            <MenuItem value="newest">Newest</MenuItem>
                            <MenuItem value="oldest">Oldest</MenuItem>
                        </TextField>
                    </Grid>

                    <Grid item sm={1}>
                        <Button disableElevation fullWidth variant="contained" color="error" onClick={this.onClearFilter}>Clear</Button>
                    </Grid>

                    <Grid item sm={1}>
                        <Button disableElevation fullWidth variant="contained" color="primary" onClick={this.onSearch}>Search</Button>
                    </Grid>

                </Grid>
            </Grid>
        </Paper>
    }

    renderLogs = () => {
        const {logs, total, filter} = this.state;

        return <Table>
            <TableHead>
                <TableRow>
                    <TableCell>#</TableCell>
                    <TableCell>ID</TableCell>
                    <TableCell>Transfer</TableCell>
                    <TableCell>Amount</TableCell>
                    <TableCell>Reason</TableCell>
                    <TableCell>Date</TableCell>
                </TableRow>
            </TableHead>
            <TableBody>
                {logs.map((log, index) => {
                    return <TableRow key={index}>
                        <TableCell>{index + 1}</TableCell>
                        <TableCell>{log.id}</TableCell>
                        <TableCell>{this.formatNumber(log.transfer)}</TableCell>
                        <TableCell>{this.formatNumber(log.amount)}</TableCell>
                        <TableCell>{log.reason}</TableCell>
                        <TableCell>{Helpers.formatDateWithTime(log.date)}</TableCell>
                    </TableRow>
                })}

                <TableRow>
                    <TableCell colSpan={20} style={{textAlign: 'center', width: "100%"}}>
                        <Pagination
                            count={filter.limit > 0 ? total / filter.limit + 1 : 1}
                            page={filter.offset / filter.limit + 1}
                            onChange={(e, page) => this.changePage(page)}
                            color="primary"
                            size="large"
                            showFirstButton
                            showLastButton
                            style={{marginTop: "20px", display: "ruby"}}
                        >
                        </Pagination>
                    </TableCell>
                </TableRow>
            </TableBody>
        </Table>
    }


    render() {
        const {classes} = this.props;
        return (
            <Paper className={classes.paper} elevation={0}>
                <Typography className={classes.paper} variant="h6">{`Ruby log for UID: ${this.state.userId}`}</Typography>
                {this.renderFilter()}
                {this.renderLogs()}
            </Paper>
        )
    }
}

const styles: any = () => ({
    paper: {
        padding: 8,
        backgroundColor: "black"
    },
});

export const PlayerRubyLogs = withStyles(styles)(PlayerRubyLogsMain);